
import React from 'react';

interface State<T = any> {
  visible: boolean;
  value?: T;
}

export interface UseDialogResult<T = any> extends State<T> {
  open: (initValue?: T) => void;
  close: () => void;
}


export const useDialog = <T = any>() => {
  const [state, setState] = React.useState<State<T>>({ visible: false });

  const open = (value: T) => {
    setState({ visible: true, value });
  };

  const close = () => {
    setState({ visible: false, value: undefined });
  };

  return {
    visible: state.visible,
    value: state.value,
    open,
    close
  };
};
